import "@zenlayer/zen-design/esm/spin/style";
import _Spin from "@zenlayer/zen-design/esm/spin";
import React, { lazy } from 'react';
import { borwserHistory, customRequestIdleCallback } from '@zenlayer/util';
import { jsx as _jsx } from "react/jsx-runtime";
// class ErrorBoundary extends React.Component<
//   React.PropsWithChildren,
//   { hasError: boolean }
// > {
//   constructor(props: React.PropsWithChildren) {
//     super(props);
//     this.state = { hasError: false };
//   }
//   static getDerivedStateFromError(error: Error) {
//     // Update state so the next render will show the fallback UI.
//     console.log(error);
//     borwserHistory.push('/exception?code=504', undefined);
//     return { hasError: true };
//   }
//   componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
//     // You can also log the error to an error reporting service
//     // logErrorToMyService(error, errorInfo);
//     console.log(error, errorInfo);
//   }
//   render() {
//     return this.props.children;
//   }
// }

/**
 * 懒加载并可预加载 React 组件
 * @function
 * @param {() => Promise<{ default: T }>} factory - 返回 Promise 的函数，该 Promise 解析后包含默认导出的 React 组件
 * @param {boolean} autoPreload - 是否自动预加载组件默认false
 * @returns @returns {React.LazyExoticComponent<T> & { preload: () => void; cancelPreload: () => void; }}
 * @example
 * const LazyComponent = lazyWithPreload(() => import('./LazyComponent'), true);
 */
export function lazyWithPreload(factory) {
  var autoPreload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var withChtchFactory = function withChtchFactory() {
    return factory().catch(function (e) {
      if (e) {
        //静态资源问题
        if (e.name === 'ChunkLoadError') {
          //请求超时
          if (e.type === 'timeout') {
            borwserHistory.push('/error?code=504', undefined);
          } else if (e.type === 'error') {
            window.location.reload();
          }
        }
      }

      return {
        default: function _default() {
          return /*#__PURE__*/_jsx(_Spin, {});
        }
      };
    });
  };

  var Component = /*#__PURE__*/lazy(withChtchFactory);
  Component.preload = withChtchFactory;
  var timerId;

  if (autoPreload) {
    timerId = window.setTimeout(function () {
      customRequestIdleCallback(function () {
        Component.preload();
      });
    }, 4000);
  }

  Component.cancelPreload = function () {
    if (timerId) {
      clearTimeout(timerId);
    }
  };

  return Component; // return () => (
  //   <ErrorBoundary>
  //     <Component />
  //   </ErrorBoundary>
  // );
}